




























import { StatParams } from '@/store/interfaces/stats';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'CustomStatCardMain',
  props: {
    title: {
      type: String,
      required: true,
    },
    total: {
      type: String,
      required: true,
    },
    values: {
      type: Array as PropType<StatParams[] & Record<string, number>[]>,
      required: true,
    },
    stats: {
      type: Object,
      required: true,
    },
  },
  methods: {
    calculatePercentage(total: number, value: number): number {
      const percentage = 100 * value / total;
      return total === 0 ? 0 : Math.round(100 * percentage) / 100;
    },
  },
});
